import { render } from "./AlbumTopMatter.vue?vue&type=template&id=3bb55fbe&ts=true"
import script from "./AlbumTopMatter.vue?vue&type=script&lang=ts"
export * from "./AlbumTopMatter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__